export default __webpack_public_path__ + "static/media/cycling.77a55c1f.jpg";